/**
* 全局配置信息， 包含网站标题，  动态组件定义
*
* @author terrfly
* @site
* @date 2021/5/8 07:18
*/

/** 应用配置项 **/
export default {
  APP_TITLE: 'Otcpe商户系统', // 设置浏览器title
  ACCESS_TOKEN_NAME: 'iToken' // 设置请求token的名字， 用于请求header 和 localstorage中存在名称
}

/**
 * 与后端开发人员的路由名称及配置项
 * 组件名称 ：{ 默认跳转路径（如果后端配置则已动态配置为准）， 组件渲染 }
 * */
export const asyncRouteDefine = {

  'CurrentUserInfo': { defaultPath: '/current/userinfo', component: () => import('@/views/current/UserinfoPage') }, // 用户设置

  'MainPage': { defaultPath: '/main', component: () => import('@/views/dashboard/index') },
  'SysUserPage': { defaultPath: '/users', component: () => import('@/views/sysuser/SysUserPage') },
  'RolePage': { defaultPath: '/roles', component: () => import('@/views/role/RolePage') },

  'MchAppPage': { defaultPath: '/apps', component: () => import ('@/views/mchApp/List') }, // 商户应用列表
  'MchTransferPage': { defaultPath: '/doTransfer', component: () => import ('@/views/transfer/MchTransferPage') }, // 转账
  'RechargeOrderListPage': { defaultPath: '/rechargeOrder', component: () => import('@/views/order/recharge/RechargeOrderList') }, // 充值订单列表
  // 通道列表
  'ChannelListPage': { defaultPath: '/channel', component: () => import('@/views/channel/ChannelListPage') },
  // 资金流水
  'FundFlowPage': { defaultPath: '/fundFlow', component: () => import('@/views/fundFlow/FundFlowPage') },

  'PayOrderListPage': { defaultPath: '/payOrder', component: () => import('@/views/order/pay/PayOrderList') }, // 支付订单列表
  'OrderSendPage': { defaultPath: '/order/send', component: () => import('@/views/order/pay/SendOrderList') }, // 代付订单列表
  'OrderReceivePage': { defaultPath: '/order/receive', component: () => import('@/views/order/pay/ReceiveOrderList') }, // 代收订单列表
  'RefundOrderListPage': { defaultPath: '/refundOrder', component: () => import('@/views/order/refund/RefundOrderList') }, // 退款订单列表
  'TransferOrderListPage': { defaultPath: '/transferOrder', component: () => import('@/views/order/transfer/TransferOrderList') }, // 转账订单

  'DivisionReceiverGroupPage': { defaultPath: '/divisionReceiverGroup', component: () => import('@/views/division/group/DivisionReceiverGroupPage') }, // 分账账号组管理
  'DivisionReceiverPage': { defaultPath: '/divisionReceiver', component: () => import('@/views/division/receiver/DivisionReceiverPage') }, // 分账账号管理
  'DivisionRecordPage': { defaultPath: '/divisionRecord', component: () => import('@/views/division/record/DivisionRecordPage') }, // 分账记录
   // 结算
   'SettlementApply': { defaultPath: '/settlement/apply', component: () => import('@/views/settlement/apply/index') }, // 结算申请
   'SettlementRecord': { defaultPath: '/settlement/record', component: () => import('@/views/settlement/index') }, // 结算记录
   'SettlementAccount': { defaultPath: '/settlement/bank-account', component: () => import('@/views/settlement/bank-account/index') }, // 结算账户

  //  对接模块
  'ChannelTestPage': { defaultPath: '/channel-test', component: () => import('@/views/api/index') }, // 通道测试
  // 对接信息
  'ApiInfoPage': { defaultPath: '/api/info', component: () => import('@/views/api/info/index') }, // 对接信息
  // 接口文档
  'IntegrationDocPage': { defaultPath: '/integration-doc', component: () => import('@/views/api/doc/index') }, // 接口文档
  // 导出记录
  ExportRecord: { defaultPath: '/export-record', component: () => import('@/views/export/index') }

}
